import React from 'react';

import CustomerDrawer from '@components/ContactDetails/CustomerDetails/Drawer/CustomerDrawer';
import NwDrawer from '@components/Gui/NwDrawer';
import CreateInvoiceDrawer from '@components/InvoicesAndCreditNotes/CreateInvoiceDrawer';
import InvoiceDrawer from '@components/InvoicesAndCreditNotes/InvoiceDrawer';
import CreatePaymentDrawer from '@components/Payments/CreatePaymentDrawer';
import PaymentDrawer from '@components/Payments/PaymentDrawer';
import PdfPrintDrawer from '@components/PdfPrintDrawer/PdfPrintDrawer';
import ProjectDrawer from '@components/Project/ProjectDrawer';
import TransactionDetailDrawer from '@components/Transactions/TransactionsDrawer/TransactionDetailDrawer';

import AddToInvoiceDrawer from '../Invoices/AddToInvoiceDrawer';

/**
 * StatementDrawers
 *
 * Shared drawer components for both payable and receivable statements
 */
const StatementDrawers = ({
    // Transaction Detail
    showTransactionDetailDrawer,
    selectedTransaction,
    handleCloseDetailDrawer,
    onUpdateTransaction,
    onTransactionRemoved,
    // PDF Print
    docVersion,
    setDocVersion,
    // Service/Customer
    isServiceDrawer,
    serviceId,
    handleCloseServiceDrawer,
    // Payment
    showPaymentDrawer,
    setShowPaymentDrawer,
    paymentData,
    handlePaymentCreation,
    selectedPayment,
    handleClosePaymentDrawer,
    contactType,
    // Invoice
    showInvoiceDrawer,
    setShowInvoiceDrawer,
    invoiceData,
    handleInvoiceCreation,
    selectedInvoice,
    handleCloseInvoiceDrawer,
    // Add to existing invoice
    addToInvoiceData,
    handleCloseAddToInvoiceDrawer,
    handleRowsAddedToInvoice,
    // Project (for receivable)
    projectPreviewID,
    handleCloseProjectDrawer,
}) => {
    return (
        <>
            {showTransactionDetailDrawer && (
                <TransactionDetailDrawer
                    transaction={selectedTransaction}
                    projectId={selectedTransaction.Project?.ID}
                    onClose={handleCloseDetailDrawer}
                    onUpdateTransaction={onUpdateTransaction}
                    onTransactionRemoved={onTransactionRemoved}
                />
            )}
            {docVersion && (
                <NwDrawer
                    onClose={() => setDocVersion(null)}
                    padding="0px"
                    title="Print Details"
                    visible={true}
                    whiteBg={false}
                    width="80vw"
                    maxWidth={'1024px'}
                >
                    <PdfPrintDrawer docVersion={docVersion} />
                </NwDrawer>
            )}
            {isServiceDrawer && <CustomerDrawer customerID={serviceId} onClose={handleCloseServiceDrawer} />}
            {showPaymentDrawer && (
                <CreatePaymentDrawer
                    onClose={() => {
                        setShowPaymentDrawer(false);
                    }}
                    data={paymentData}
                    onPaymentCreated={handlePaymentCreation}
                />
            )}
            {showInvoiceDrawer && (
                <CreateInvoiceDrawer
                    onClose={() => setShowInvoiceDrawer(false)}
                    onInvoiceCreated={handleInvoiceCreation}
                    data={invoiceData}
                />
            )}
            {addToInvoiceData && (
                <AddToInvoiceDrawer
                    data={addToInvoiceData}
                    onClose={handleCloseAddToInvoiceDrawer}
                    onRowsAdded={handleRowsAddedToInvoice}
                />
            )}
            {selectedInvoice && <InvoiceDrawer invoiceId={selectedInvoice} onClose={handleCloseInvoiceDrawer} />}
            {selectedPayment && (
                <PaymentDrawer
                    paymentID={selectedPayment}
                    contactType={contactType}
                    onClose={handleClosePaymentDrawer}
                />
            )}
            {projectPreviewID && <ProjectDrawer projectId={projectPreviewID} onClose={handleCloseProjectDrawer} />}
        </>
    );
};

export default StatementDrawers;
